import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import Header from "@/components/layout/Header";
import LoginForm from "@/components/auth/LoginForm";
import { Building2, Users, Shield } from "lucide-react";

const Auth = () => {
  const [selectedRole, setSelectedRole] = useState<'admin' | 'company' | 'employee' | null>(null);

  const roles = [
    {
      id: 'admin' as const,
      icon: Shield,
      title: "Administrateur",
      description: "Accès complet pour la gestion des demandes d'entreprise"
    },
    {
      id: 'company' as const,
      icon: Building2,
      title: "Entreprise",
      description: "Gestion de vos employés et de leur télétravail"
    },
    {
      id: 'employee' as const,
      icon: Users,
      title: "Employé",
      description: "Accès à vos demandes de télétravail et votre solde de points"
    }
  ];

  if (!selectedRole) {
    return (
      <div className="min-h-screen bg-gradient-subtle">
        <Header />
        <div className="container mx-auto py-16 px-4">
          <Card className="max-w-2xl mx-auto">
            <CardHeader className="text-center">
              <CardTitle className="text-2xl">Choisissez votre profil</CardTitle>
              <CardDescription>
                Sélectionnez le type de compte avec lequel vous souhaitez vous connecter
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              {roles.map((role) => (
                <Button
                  key={role.id}
                  variant="outline"
                  className="w-full justify-start p-4 sm:p-6 h-auto min-h-[80px]"
                  onClick={() => setSelectedRole(role.id)}
                >
                  <div className="flex items-start sm:items-center gap-3 sm:gap-4 w-full">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                      <role.icon className="h-5 w-5 sm:h-6 sm:w-6 text-primary" />
                    </div>
                    <div className="text-left flex-1 min-w-0">
                      <div className="font-semibold text-sm sm:text-base">{role.title}</div>
                      <div className="text-xs sm:text-sm text-muted-foreground whitespace-normal break-words">{role.description}</div>
                    </div>
                  </div>
                </Button>
              ))}
            </CardContent>
          </Card>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-subtle">
      <Header />
      <div className="container mx-auto py-16 px-4">
        <div className="max-w-md mx-auto">
          <div className="text-center mb-6">
            <Button 
              variant="ghost" 
              onClick={() => setSelectedRole(null)}
              className="mb-4"
            >
              ← Retour
            </Button>
            <h1 className="text-2xl font-bold">Connexion {selectedRole}</h1>
            <p className="text-muted-foreground">
              Connectez-vous à votre espace {selectedRole}
            </p>
          </div>
          
          <LoginForm role={selectedRole} />
        </div>
      </div>
    </div>
  );
};

export default Auth;